<template>
<v-container>
  <v-layout>
    <v-flex xs12 sm6 offset-sm3>
      <v-flex xs12 md44 class='my-3'>
        <div class="text-xs-center">
          <v-avatar size='40px'>
            <img v-if="photoURL" v-bind:src="item.avatar">
            <img v-else v-bind:src="defaultTeamAvatar">
          </v-avatar>
          <div v-if='teamObj.teamName' class='text-xs-center'>
            <h2 class='headline'>{{ teamObj.teamName }}</h2>
            <!--
            <span class='subheading'>
              チームロゴの写真を編集
            </span>
            -->
          </div>
          <div v-else class='text-xs-center'>
            <h2 class='headline'>新しいチームの誕生</h2>
            <span class='subheading'>
              あなたのチームを登録しましょう
            </span>
          </div>
        </div>
      </v-flex>

  <form>
    <v-text-field
      label='チームネーム'
      v-model='teamObj.teamName'
      required
    ></v-text-field>
    <v-text-field
      label='チーム紹介'
      v-model='teamObj.teamInfo'
      required
    ></v-text-field>

    <v-select
      label='地域'
      v-model='teamObj.select'
      :items='items'
    ></v-select>

  </form>


<!--
<v-btn v-if='this.isRegist == false'   :to='this.to'>メンバーを確認</v-btn>
-->
<div  class="orange--text">メンバー管理機能を準備中</div>



<v-btn :disabled="!(teamObj.teamName && teamObj.teamInfo && teamObj.select)" v-if='!this.isRegist' block secondary green @click='create'>登録</v-btn>

<v-btn :disabled="!(teamObj.teamName && teamObj.teamInfo && teamObj.select)" v-if='this.isRegist' block secondary green @click='update'>更新する</v-btn>


    </v-flex>
  </v-layout>
</v-container>
</template>


<script>
import { mapGetters } from 'vuex'
import firebase from 'firebase'
require('firebase/firestore')
// Initialize Cloud Firestore through Firebase

export default {
  components: {
    firebase
  },
  data () {
    return {
      valid: true,
      teamNameeRules: [
        (v) => !!v || 'Name is required'
      ],
      url: '',
      teamName: 'any',
      photoURL: '',
      teamInfo: null,
      name: '',
      items: ['東京都', '神奈川県', '埼玉県', '千葉県', '茨城県', '栃木県'],
      teamObj: {},
      to: '/team/' + this.$route.params.id + '/members',
      isRegist: false,
      // user: firebase.auth().currentUser,
      defaultTeamAvatar: '/static/defaultteam.png'
    }
  },
  created () {
    // select teams

    if (this.$route.params.id !== 'regist') {
      console.log(this.$route.params.id)
      this.isRegist = false
    }

    this.getTeam()
    //
  },
  methods: {
    create: function () {
      console.log('create')
      var db = firebase.firestore()
      let uid = this.user.uid
      db.collection('teams').add(this.teamObj).then(function (docRef) {
        console.log('Document successfully written!')
        // m2m
        let m2mObj = {role: 'ADMIN', team: docRef.id, user: uid}
        db.collection('m2m_teams_users').add(m2mObj).then(() => {
          console.log('Document successfully written!')
        })
      })
      this.$router.push('/tournament')
    },
    update: function () {
      console.log(this.teamName)
      //
      // firestore
      var db = firebase.firestore()
      var docRef = db.collection('teams').doc(this.$route.params.id)

      docRef.update(this.teamObj).then(() => {
        console.log('Document successfully updated!')
      })
      .catch(function (error) {
        // The document probably doesn't exist.
        console.error('Error updating document: ', error)
      })
      this.$router.push('/tournament')
    },
    // duplicate
    getTeam: function () {
      console.log(this.teamName)
      var db = firebase.firestore()
      var docRef = db.collection('teams').doc(this.$route.params.id)

      // Read the document.
      docRef.get().then(doc => {
        if (doc.exists) {
          // Document read successfully.
          this.teamObj = doc.data()
          this.isRegist = true
          console.log('this->' + this.teamObj.teamName)
        } else {
          console.log('No such document!')
        }
      }).catch(function (error) {
        console.log('Error getting document:', error)
      })
    },
    move: function () {
      this.$router.push('/user/profile')
    }
  },
  computed: {
    ...mapGetters({
      user: 'user'
    })
  }
}
</script>


<style>
.ggmap {
position: relative;
padding-bottom: 56.25%;
padding-top: 30px;
height: 0;
overflow: hidden;
}
 
.ggmap iframe,
.ggmap object,
.ggmap embed {
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/team/TeamProfile.vue